export interface Movie {
  id: string;
  title: string;
  originalTitle: string;
  year: number;
  category: string;
  subCategory: string;
  rating: number;
  duration: string;
  region: string;
  director: string;
  cast: string[];
  description: string;
  posterSrc: string;
  coverSrc: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  releaseDate: string;
  language: string;
}

export interface MovieCategory {
  slug: string;
  name: string;
  icon: string;
  count: number;
}

export const movieCategories: MovieCategory[] = [
  { slug: 'dongzuo', name: '动作片', icon: 'ri-sword-line', count: 48 },
  { slug: 'xiju', name: '喜剧片', icon: 'ri-emotion-laugh-line', count: 36 },
  { slug: 'aiqing', name: '爱情片', icon: 'ri-heart-line', count: 29 },
  { slug: 'kehuan', name: '科幻片', icon: 'ri-rocket-line', count: 22 },
  { slug: 'kongbu', name: '恐怖片', icon: 'ri-ghost-line', count: 18 },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-film-line', count: 15 },
  { slug: 'donghua', name: '动画片', icon: 'ri-emotion-happy-line', count: 31 },
  { slug: 'juqing', name: '剧情片', icon: 'ri-movie-line', count: 42 },
  { slug: 'xuanyi', name: '悬疑片', icon: 'ri-search-eye-line', count: 24 },
  { slug: 'zhanzheng', name: '战争片', icon: 'ri-flag-line', count: 12 },
];

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '龙拳风云',
    originalTitle: 'Dragon Fist Storm',
    year: 2025,
    category: 'dongzuo',
    subCategory: '动作',
    rating: 8.7,
    duration: '128分钟',
    region: '中国内地',
    director: '陈凯文',
    cast: ['张毅恒', '李雨桐', '王志刚', '林晓峰'],
    description: '在黑暗势力横行的都市丛林中，退役特种兵龙飞为保护家人，重出江湖对抗跨国犯罪集团。一场惊心动魄的正邪较量就此展开，拳拳到肉的格斗场面与扣人心弦的剧情交织，打造年度最强动作巨制。龙飞能否在这场生死对决中守护自己所珍视的一切？',
    posterSrc: 'https://readdy.ai/api/search-image?query=Chinese%20action%20movie%20poster%2C%20martial%20arts%20fighter%20in%20dark%20urban%20setting%2C%20dramatic%20lighting%2C%20cinematic%20poster%20style%2C%20golden%20and%20dark%20tones%2C%20professional%20movie%20poster%20design%20with%20Chinese%20text%20placeholder%2C%20high%20contrast%2C%20film%20grain%20texture&width=400&height=560&seq=movie-poster-01&orientation=portrait',
    coverSrc: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20action%20movie%20scene%2C%20martial%20arts%20fighter%20silhouette%20against%20neon%20cityscape%20at%20night%2C%20dramatic%20cinematic%20lighting%2C%20rain%20slicked%20streets%2C%20atmospheric%20fog%2C%20golden%20warm%20tones%20mixed%20with%20dark%20shadows%2C%20widescreen%20cinematic%20composition%2C%20professional%20film%20photography&width=1280&height=600&seq=movie-cover-01&orientation=landscape',
    tags: ['动作', '犯罪', '热血'],
    isHot: true,
    isNew: true,
    releaseDate: '2025-06-15',
    language: '国语',
  },
  {
    id: 'movie-2',
    title: '星际迷途：重生',
    originalTitle: 'Star Drift: Rebirth',
    year: 2025,
    category: 'kehuan',
    subCategory: '科幻',
    rating: 9.1,
    duration: '145分钟',
    region: '美国',
    director: '詹姆斯·诺兰',
    cast: ['汤姆·哈里斯', '艾玛·斯通', '迈克尔·陈'],
    description: '公元2157年，人类文明在星际殖民时代遭遇未知威胁。一支精英宇航员小队奉命前往深空探索神秘信号的来源。在这场跨越光年的旅程中，他们将面对超越人类认知的宇宙奥秘，以及来自人性深处的终极考验。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20poster%2C%20astronaut%20floating%20in%20deep%20space%20with%20distant%20galaxy%2C%20cinematic%20poster%20design%2C%20blue%20and%20purple%20cosmic%20colors%2C%20professional%20movie%20poster%2C%20dramatic%20lighting%2C%20film%20grain&width=400&height=560&seq=movie-poster-02&orientation=portrait',
    coverSrc: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%2C%20spaceship%20approaching%20massive%20alien%20structure%20in%20deep%20space%2C%20nebulae%20and%20stars%2C%20cinematic%20lighting%2C%20widescreen%20composition%2C%20atmospheric%2C%20professional%20film%20photography%2C%20dark%20cosmic%20background&width=1280&height=600&seq=movie-cover-02&orientation=landscape',
    tags: ['科幻', '冒险', '太空'],
    isHot: true,
    isNew: true,
    releaseDate: '2025-07-01',
    language: '英语',
  },
  {
    id: 'movie-3',
    title: '笑傲江湖之欢乐客栈',
    originalTitle: 'Inn of Laughter',
    year: 2025,
    category: 'xiju',
    subCategory: '喜剧',
    rating: 7.9,
    duration: '108分钟',
    region: '中国内地',
    director: '周星辉',
    cast: ['沈鹏飞', '贾琳琳', '王宝乐', '马丽华'],
    description: '一间开在古城小巷里的客栈，汇聚了来自五湖四海的奇人异士。当年轻老板决定将客栈改造成网红打卡地时，一连串令人捧腹的乌龙事件接踵而至。欢声笑语中，每个人都在这里找到了属于自己的故事。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%2C%20colorful%20traditional%20Chinese%20inn%20with%20funny%20characters%2C%20bright%20warm%20colors%2C%20playful%20atmosphere%2C%20cinematic%20poster%20style%2C%20professional%20movie%20poster%20design&width=400&height=560&seq=movie-poster-03&orientation=portrait',
    coverSrc: 'https://readdy.ai/api/search-image?query=Warm%20and%20cozy%20traditional%20Chinese%20inn%20interior%2C%20colorful%20decorations%2C%20group%20of%20diverse%20characters%20laughing%20together%2C%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20festive%20atmosphere%2C%20professional%20film%20photography&width=1280&height=600&seq=movie-cover-03&orientation=landscape',
    tags: ['喜剧', '古装', '温情'],
    isHot: false,
    isNew: true,
    releaseDate: '2025-07-20',
    language: '国语',
  },
  {
    id: 'movie-4',
    title: '深海魅影',
    originalTitle: 'Phantom of the Deep',
    year: 2024,
    category: 'kongbu',
    subCategory: '恐怖',
    rating: 7.5,
    duration: '98分钟',
    region: '日本',
    director: '黑泽明彦',
    cast: ['佐藤健太', '桥本环奈', '田中裕子'],
    description: '一支海洋科考队在太平洋深处发现了一座沉没的古城遗迹。随着探索的深入，队员们开始遭遇无法解释的超自然现象。深海之下，古老的诅咒正在苏醒，没有人能逃过这场来自深渊的恐惧。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Horror%20movie%20poster%2C%20dark%20underwater%20scene%20with%20eerie%20glowing%20eyes%20in%20the%20deep%2C%20cold%20blue%20tones%2C%20cinematic%20horror%20poster%20design%2C%20atmospheric%2C%20professional%20movie%20poster&width=400&height=560&seq=movie-poster-04&orientation=portrait',
    coverSrc: 'https://readdy.ai/api/search-image?query=Dark%20underwater%20scene%2C%20ancient%20sunken%20ruins%20in%20the%20ocean%20depths%2C%20eerie%20blue%20light%2C%20mysterious%20shadows%2C%20cinematic%20widescreen%20composition%2C%20atmospheric%20horror%20photography&width=1280&height=600&seq=movie-cover-04&orientation=landscape',
    tags: ['恐怖', '惊悚', '海洋'],
    isHot: true,
    isNew: false,
    releaseDate: '2024-10-31',
    language: '日语',
  },
  {
    id: 'movie-5',
    title: '倾城之恋',
    originalTitle: 'Love in the City',
    year: 2025,
    category: 'aiqing',
    subCategory: '爱情',
    rating: 8.2,
    duration: '115分钟',
    region: '韩国',
    director: '朴智恩',
    cast: ['金秀贤', '全智贤', '李敏镐'],
    description: '首尔的秋天，一位从巴黎归来的钢琴家与一位经营独立书店的女孩相遇。两个来自不同世界的人，在音乐与文字的浪漫交织中，谱写出一段跨越文化的心灵恋曲。当现实与理想碰撞，他们能否坚守这份来之不易的爱情？',
    posterSrc: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20movie%20poster%2C%20couple%20in%20autumn%20Seoul%20street%20with%20falling%20leaves%2C%20warm%20golden%20and%20pink%20tones%2C%20cinematic%20romance%20poster%2C%20soft%20lighting%2C%20professional%20movie%20poster&width=400&height=560&seq=movie-poster-05&orientation=portrait',
    coverSrc: 'https://readdy.ai/api/search-image?query=Romantic%20autumn%20scene%20in%20Seoul%2C%20couple%20walking%20through%20golden%20leaves%20on%20a%20quiet%20street%2C%20warm%20sunset%20lighting%2C%20cinematic%20widescreen%2C%20soft%20bokeh%2C%20professional%20film%20photography&width=1280&height=600&seq=movie-cover-05&orientation=landscape',
    tags: ['爱情', '浪漫', '音乐'],
    isHot: false,
    isNew: true,
    releaseDate: '2025-05-20',
    language: '韩语',
  },
  {
    id: 'movie-6',
    title: '暗夜追踪',
    originalTitle: 'Night Pursuit',
    year: 2024,
    category: 'xuanyi',
    subCategory: '悬疑',
    rating: 8.4,
    duration: '132分钟',
    region: '英国',
    director: '克里斯托弗·李',
    cast: ['本尼迪克特·王', '艾米莉亚·克拉克', '汤姆·哈迪'],
    description: '伦敦警探詹姆斯在一宗看似普通的失踪案中，揭开了一个横跨欧洲的人口贩卖网络。随着调查不断深入，他发现真相远比想象中更加黑暗，而最大的危险正潜伏在他的身边。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%2C%20detective%20in%20rainy%20London%20street%20at%20night%2C%20noir%20style%2C%20dark%20tones%20with%20red%20accents%2C%20cinematic%20poster%2C%20professional%20movie%20poster%20design&width=400&height=560&seq=movie-poster-06&orientation=portrait',
    coverSrc: 'https://readdy.ai/api/search-image?query=Noir%20style%20London%20street%20at%20night%2C%20rain%20slicked%20roads%2C%20detective%20silhouette%20under%20streetlamp%2C%20foggy%20atmosphere%2C%20cinematic%20widescreen%2C%20dark%20and%20moody%2C%20professional%20film%20photography&width=1280&height=600&seq=movie-cover-06&orientation=landscape',
    tags: ['悬疑', '犯罪', '推理'],
    isHot: true,
    isNew: false,
    releaseDate: '2024-12-05',
    language: '英语',
  },
  {
    id: 'movie-7',
    title: '长城下的守护者',
    originalTitle: 'Guardians of the Wall',
    year: 2025,
    category: 'juqing',
    subCategory: '剧情',
    rating: 8.9,
    duration: '138分钟',
    region: '中国内地',
    director: '张艺峰',
    cast: ['吴京辉', '章子怡', '刘德华', '周迅'],
    description: '在长城脚下的小村庄里，三代人守护着一段不为人知的历史。当现代化的浪潮席卷而来，老一辈的坚守与年轻一代的迷茫产生了激烈的碰撞。这不仅是一部关于长城的史诗，更是一首关于传承与变迁的时代挽歌。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20movie%20poster%2C%20elderly%20guardian%20at%20Great%20Wall%20with%20golden%20sunset%2C%20epic%20cinematic%20poster%2C%20warm%20earthy%20tones%2C%20professional%20movie%20poster%20design&width=400&height=560&seq=movie-poster-07&orientation=portrait',
    coverSrc: 'https://readdy.ai/api/search-image?query=Great%20Wall%20of%20China%20at%20golden%20sunset%2C%20small%20village%20in%20the%20distance%2C%20epic%20cinematic%20landscape%2C%20warm%20golden%20light%2C%20atmospheric%20fog%2C%20widescreen%20composition%2C%20professional%20film%20photography&width=1280&height=600&seq=movie-cover-07&orientation=landscape',
    tags: ['剧情', '历史', '家庭'],
    isHot: true,
    isNew: false,
    releaseDate: '2025-04-10',
    language: '国语',
  },
  {
    id: 'movie-8',
    title: '动物奇缘',
    originalTitle: 'Wild Hearts',
    year: 2025,
    category: 'donghua',
    subCategory: '动画',
    rating: 8.5,
    duration: '95分钟',
    region: '美国',
    director: '皮特·道格特',
    cast: ['汤姆·赫兰德', '赞达亚', '杰克·布莱克'],
    description: '在繁华都市的动物园里，一只梦想成为探险家的小狐狸偷偷溜出了栅栏。在城市的钢铁丛林中，它遇到了一群性格迥异的动物伙伴，开启了一段不可思议的冒险旅程。这趟旅程让每个角色都找到了真正的自己。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Animated%20movie%20poster%2C%20cute%20fox%20and%20animal%20friends%20in%20colorful%20city%2C%20vibrant%20warm%20colors%2C%20playful%20style%2C%20professional%20animation%20movie%20poster&width=400&height=560&seq=movie-poster-08&orientation=portrait',
    coverSrc: 'https://readdy.ai/api/search-image?query=Colorful%20animated%20cityscape%20with%20cute%20animals%20exploring%20together%2C%20bright%20sunlight%2C%20vibrant%20warm%20colors%2C%20cinematic%20widescreen%2C%20whimsical%20atmosphere%2C%20professional%20animation%20style&width=1280&height=600&seq=movie-cover-08&orientation=landscape',
    tags: ['动画', '冒险', '友情'],
    isHot: false,
    isNew: true,
    releaseDate: '2025-06-01',
    language: '英语',
  },
  {
    id: 'movie-9',
    title: '铁血战旗',
    originalTitle: 'Banner of Iron',
    year: 2024,
    category: 'zhanzheng',
    subCategory: '战争',
    rating: 8.1,
    duration: '152分钟',
    region: '中国内地',
    director: '林超群',
    cast: ['张涵予', '彭于晏', '黄景瑜', '杜江'],
    description: '以抗美援朝战争为背景，讲述了一支志愿军侦察连在敌后执行特殊任务的故事。在冰天雪地的战场前线，战士们用血肉之躯筑起了保家卫国的钢铁长城。每一帧画面都在诉说着那段不可忘却的历史。',
    posterSrc: 'https://readdy.ai/api/search-image?query=War%20movie%20poster%2C%20Chinese%20soldiers%20in%20snowy%20battlefield%2C%20dramatic%20lighting%2C%20cold%20blue%20and%20red%20tones%2C%20epic%20cinematic%20poster%2C%20professional%20movie%20poster%20design&width=400&height=560&seq=movie-poster-09&orientation=portrait',
    coverSrc: 'https://readdy.ai/api/search-image?query=Epic%20winter%20battlefield%20scene%2C%20soldiers%20marching%20through%20snow%20covered%20mountains%2C%20cold%20blue%20lighting%20with%20warm%20explosions%2C%20cinematic%20widescreen%2C%20atmospheric%2C%20professional%20film%20photography&width=1280&height=600&seq=movie-cover-09&orientation=landscape',
    tags: ['战争', '历史', '爱国'],
    isHot: false,
    isNew: false,
    releaseDate: '2024-09-30',
    language: '国语',
  },
  {
    id: 'movie-10',
    title: '冰川时代：极地大冒险',
    originalTitle: 'Ice World: Polar Quest',
    year: 2025,
    category: 'donghua',
    subCategory: '动画',
    rating: 7.8,
    duration: '88分钟',
    region: '美国',
    director: '安德鲁·斯坦顿',
    cast: ['克里斯·帕拉特', '安妮·海瑟薇', '威尔·史密斯'],
    description: '当气候变化威胁到北极家园，一群勇敢的小动物踏上了寻找新栖息地的旅程。在穿越冰原、翻越雪山的途中，它们学会了团结、勇气与友谊的真正含义。爆笑与感动交织的极地冒险，适合全家观看。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Animated%20movie%20poster%2C%20cute%20arctic%20animals%20on%20ice%20adventure%2C%20cool%20blue%20and%20white%20tones%2C%20playful%20animation%20style%2C%20professional%20movie%20poster%20design&width=400&height=560&seq=movie-poster-10&orientation=portrait',
    coverSrc: 'https://readdy.ai/api/search-image?query=Cute%20animated%20arctic%20landscape%20with%20animals%20traveling%20across%20ice%20and%20snow%2C%20northern%20lights%20in%20sky%2C%20cool%20blue%20tones%2C%20cinematic%20widescreen%2C%20whimsical%20atmosphere&width=1280&height=600&seq=movie-cover-10&orientation=landscape',
    tags: ['动画', '冒险', '合家欢'],
    isHot: false,
    isNew: true,
    releaseDate: '2025-01-15',
    language: '英语',
  },
  {
    id: 'movie-11',
    title: '都市夜未眠',
    originalTitle: 'Sleepless in the City',
    year: 2024,
    category: 'aiqing',
    subCategory: '爱情',
    rating: 7.6,
    duration: '110分钟',
    region: '中国内地',
    director: '郭敬明轩',
    cast: ['刘昊然', '周冬雨', '易烊千玺'],
    description: '在上海的霓虹灯下，两个失意的都市男女因为一次偶然的拼车而相遇。从陌生到熟悉，从误解到相知，他们在城市的深夜里互相取暖，在彼此的故事里找到了生活的光亮。这是一个关于都市孤独与温暖相遇的当代爱情故事。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20movie%20poster%2C%20couple%20in%20Shanghai%20night%20city%20with%20neon%20lights%2C%20warm%20pink%20and%20purple%20tones%2C%20cinematic%20poster%20style%2C%20professional%20movie%20poster&width=400&height=560&seq=movie-poster-11&orientation=portrait',
    coverSrc: 'https://readdy.ai/api/search-image?query=Romantic%20Shanghai%20cityscape%20at%20night%20with%20neon%20lights%2C%20couple%20on%20rooftop%2C%20warm%20bokeh%20city%20lights%2C%20cinematic%20widescreen%2C%20atmospheric%2C%20professional%20film%20photography&width=1280&height=600&seq=movie-cover-11&orientation=landscape',
    tags: ['爱情', '都市', '治愈'],
    isHot: false,
    isNew: false,
    releaseDate: '2024-08-14',
    language: '国语',
  },
  {
    id: 'movie-12',
    title: '极限狙击',
    originalTitle: 'Extreme Snipe',
    year: 2024,
    category: 'dongzuo',
    subCategory: '动作',
    rating: 8.0,
    duration: '118分钟',
    region: '中国香港',
    director: '林超杰',
    cast: ['古天乐', '刘青云', '张家辉', '吴镇宇'],
    description: '一名退休的飞虎队狙击手被卷入一场国际恐怖组织的阴谋中。当昔日的战友成为人质，他必须在48小时内完成五次不可能的狙击任务。每一枪都关乎生死，每一步都暗藏杀机。港式警匪动作片的巅峰回归。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20action%20movie%20poster%2C%20sniper%20on%20rooftop%20with%20city%20skyline%2C%20dramatic%20lighting%2C%20dark%20green%20and%20gold%20tones%2C%20cinematic%20poster%2C%20professional%20movie%20poster&width=400&height=560&seq=movie-poster-12&orientation=portrait',
    coverSrc: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20city%20skyline%20at%20dusk%2C%20sniper%20silhouette%20on%20high%20building%20rooftop%2C%20dramatic%20golden%20hour%20lighting%2C%20cinematic%20widescreen%2C%20atmospheric%2C%20professional%20film%20photography&width=1280&height=600&seq=movie-cover-12&orientation=landscape',
    tags: ['动作', '警匪', '狙击'],
    isHot: true,
    isNew: false,
    releaseDate: '2024-07-28',
    language: '粤语/国语',
  },
];

export const hotMovies = movies.filter((m) => m.isHot);
export const newMovies = movies.filter((m) => m.isNew);

export function getMovieById(id: string): Movie | undefined {
  return movies.find((m) => m.id === id);
}

export function getMoviesByCategory(slug: string): Movie[] {
  return movies.filter((m) => m.category === slug);
}

export function getRelatedMovies(movie: Movie, limit: number = 5): Movie[] {
  return movies
    .filter((m) => m.id !== movie.id && m.category === movie.category)
    .slice(0, limit);
}